/**
 * Enum para os tipos de entrega de produtos.
 * O valor numérico deve ser sincronizado com os IDs do backend.
 *
 * Exemplo:
 * - Impresso: Produtos físicos que necessitam de frete.
 * - Digital: Produtos digitais que não têm frete.
 */
export enum DeliveryType {
  Impresso = 1, // Valor provisório. Ajustar conforme o backend.
  Digital = 2,
  Servico = 3,
  Escola = 4,
}

export interface Invoicing {
  id: number;
  invoicingName: string;
  deliveryTypeId: number;
  invoicingQtd: number;
  currentMonth: number | null;
  currentYear: number | null;
  createdAt: string;
  updatedAt: string;
}

export enum InvoicingDeliveryType {
  Anual = 1,
  Semestral = 2,
}

export enum Months {
  Janeiro = 1,
  Fevereiro = 2,
  Março = 3,
  Abril = 4,
  Maio = 5,
  Junho = 6,
  Julho = 7,
  Agosto = 8,
  Setembro = 9,
  Outubro = 10,
  Novembro = 11,
  Dezembro = 12,
}

export interface ScheduledOrder {
  id: string;
  orderNumber: string;
  clientCode: string;
  clientName: string;
  scheduledDate: string | null;
  status: "pending" | "processed" | "failed" | "processing";
  retryCount: number;
  errorMessage: string | null;
  createdAt: string;
  updatedAt: string;
  processedAt: string | null;
  createdBy: string;
}

export interface SimulatedOrderInterval {
  id?: string;
  name: string;
  deadline: string;
}

export interface SimulatedOrder {
  id: number;
  name: string;
  deadline: string;
  intervals?: SimulatedOrderInterval[];
  products: any; // JSON representation as per backend
  createdAt: string;
  updatedAt: string;
}

export type CreateSimulatedOrder = Omit<
  SimulatedOrder,
  "id" | "createdAt" | "updatedAt"
>;
